import React, { useState } from 'react';
import classes from './App.module.scss';
import { InputForm } from './components/InputForm';
import { InputData } from './components/InputForm/types';
import { OutputContainer } from './components/OutputContainer';
import { FileProcessingResult } from './types/FileProcessingResult';
import { defaultForm, defaultResp } from './defaultData';



function App() {
  const [processingData, setProcessingData] = useState<FileProcessingResult | null>(defaultResp);
  const [formData, setFormData] = useState<InputData | null>(defaultForm);

  return (
    <div className={classes.wrapper}>
      <InputForm
        onLoading={() => setProcessingData(null)}
        onProcess={(output, form) => {
          setProcessingData(output);
          setFormData(form);
        }}
      />

      <OutputContainer
        processingData={processingData}
        formData={formData}
      />
    </div>
  );
}

export default App;
